import { render } from "./QuestionnaireRevisionsPanel.vue?vue&type=template&id=1d31521a&scoped=true"
import script from "./QuestionnaireRevisionsPanel.vue?vue&type=script&lang=js"
export * from "./QuestionnaireRevisionsPanel.vue?vue&type=script&lang=js"

import "./QuestionnaireRevisionsPanel.vue?vue&type=style&index=0&id=1d31521a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d31521a"]])

export default __exports__